import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-upload\"><defs><style type=\"text/css\"></style></defs><path d=\"M611.4 650.4l-98.9-98.9-98.8 98.8-39.6-39.6 138.4-138.4L651 610.8z\" fill=\"\" p-id=\"13618\" /><path d=\"M484.706 512.056l56 0.09-0.41 256-56-0.09z\" fill=\"\" p-id=\"13619\" /><path d=\"M750 871.4H276c-64.4 0-125-25.1-170.5-70.6S34.8 694.6 34.8 630.2c0-64.4 25.1-125 70.6-170.5 39.3-39.3 89.7-63.3 144.2-69.2 5.9-60.7 32.4-117.1 76.2-160.8 49.9-49.9 116.3-77.4 186.9-77.4s137 27.5 186.9 77.4c43.7 43.7 70.2 100 76.2 160.7 54.7 5.8 105.4 29.9 144.8 69.3 45.6 45.6 70.6 106.1 70.6 170.5s-25.1 125-70.6 170.5-106.2 70.7-170.6 70.7zM275.8 445c-102 0.1-185 83.1-185 185.2S173.9 815.4 276 815.4h474c102.1 0 185.2-83.1 185.2-185.2s-83-185.1-185.1-185.2h-0.9l-28.1 0.1V417v-0.7c-0.1-114.8-93.5-208.1-208.3-208.1-114.9 0-208.3 93.4-208.3 208.2v0.5l0.1 28.1h-28.8z\" fill=\"\" p-id=\"13620\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/upload.svg
// module id = P/TB
// module chunks = 45